module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Regular-Italic.dda54e36.woff";